import * as React from 'react';
import {Component} from 'react';
import {ReactNode} from 'react';
import {Route, Switch} from 'react-router-dom';

import * as Screens from './screens';

class Routes extends Component {
    render(): ReactNode {
        return (
            <Switch>
                <Route exact path="/" component={Screens.Plans} />
            </Switch>
        );
    }
}

export default Routes;
